import type { WizardStepConfig } from '../types/wizardTypes';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WIZARD_STEPS: WizardStepConfig[] = [
  {
    id: 'tool-info',
    label: 'Tool Info',
    subtitle: 'Describe what this tool does and when to use it.',
  },
  {
    id: 'request-mapping',
    label: 'Connector Request Mapping',
    subtitle: 'Configure what gets sent to the system.',
  },
  {
    id: 'input-fields',
    label: 'MCP Input Fields',
    subtitle: 'Define the MCP fields this tool needs to run.',
  },
  {
    id: 'response-mapping',
    label: 'Response Mapping',
    subtitle: 'Define how the API response is transformed and returned.',
  },
  {
    id: 'chat-quick-actions',
    label: 'Chat Quick Actions',
    subtitle: 'Set up how the tool behaves in chat.',
  },
  {
    id: 'review',
    label: 'Review',
    subtitle: 'Review everything and save your tool.',
  },
];
